// extracted by mini-css-extract-plugin
module.exports = {"DiagramGenWrapper":"DiagramGen_DiagramGenWrapper__2oZIC"};